var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-item",class:[
    { active: _vm.activeLevelThreeId === _vm.info.meta.id}
  ],on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.i18n.t(_vm.info.meta.title))+" "),(_vm.info.hot)?_c('svg',{staticClass:"icon",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-caidanremen"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }